import { Checkbox } from 'antd';
import styled, { createGlobalStyle, css } from 'styled-components';

import colors from '../../styles/colors';

export const Styles = createGlobalStyle`

  .radio-btn {
    font-weight: normal;
    font-size: 16px;
  }

  .tabAtivo {
    color: ${colors.$light};
    background: ${colors.$brandcolor_primary_dark_green_5};

    &:hover {
      color: ${colors.$light};
    }
  }
  .tabInativo {
    color: ${colors.$brandcolor_primary_dark_green_5};
    background: ${colors.$light};

    &:hover {
      color: ${colors.$brandcolor_primary_dark_green_5};
    }
  }

  .chart-custom {
    width: 100%;
    height: 70vh;
    text-align: center;
    margin-top: 10px;
  }

  .chart-custom-loading {
    width: 100%;
    height: 70vh;
    text-align: center;
    margin-top: 10px;
    .recharts-wrapper {
      opacity: 0.5;
    }
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn, .ant-tabs-tab:hover, .ant-tabs-tab:active, .ant-tabs-tab-btn:active {
    color: ${colors.$brandcolor_primary_dark_green_5} !important;
    path {
      fill: ${colors.$brandcolor_primary_dark_green_5};
    }
  }

  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background-color: ${colors.$brandcolor_primary_dark_green_5} !important;
  }

  .radiusLeft {
    border-radius: 4px 0px 0px 4px !important;
  }

  .radiusRight {
    border-radius: 0px 4px 4px 0px !important;
  }

  .rowMensagem {
    bottom: 0;
    position: relative;
    height: 40px;
    margin-left: 12px;
  }

  .filtrosVariacaoFrete {
    width: 100% !important;
  }

  .ant-select-selector {
    border-radius: 4px !important;
  }


`;

export const CheckBoxLegend = styled(Checkbox)`
  .ant-checkbox-checked > .ant-checkbox-inner {
    ${props =>
      props.color &&
      css`
        background-color: ${props.color} !important;
        border-color: ${props.color} !important;
      `}
  }
`;
